import { render } from "./AffectedItemsTable.vue?vue&type=template&id=c38b2dfe&scoped=true"
import script from "./AffectedItemsTable.vue?vue&type=script&lang=js"
export * from "./AffectedItemsTable.vue?vue&type=script&lang=js"

import "./AffectedItemsTable.vue?vue&type=style&index=0&id=c38b2dfe&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c38b2dfe"]])

export default __exports__